import React, { useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { ReactFormGenerator } from "react-form-builder2";
import * as variables from "utils/ReactFormBuilderVariables";
import { sanitizeItems } from "utils/formDataHelper";
import { Wrapper } from "./Theme";
import { formatDateInFormData } from "./formDataHelper";

const NAME_LIMIT = 80;
const PHONE_LIMIT = 15;

const truncateNameFields = event =>
  event.map(item => {
    const label = (item.label || "").toLowerCase();
    if (label.includes("phone") && typeof item.value === "string") {
      return { ...item, value: item.value.slice(0, PHONE_LIMIT) };
    }
    const isLimitedField =
      label.includes("first name") ||
      label.includes("last name") ||
      label.includes("email") ||
      label.includes("e-mail");
    if (isLimitedField && typeof item.value === "string") {
      return { ...item, value: item.value.slice(0, NAME_LIMIT) };
    }
    return item;
  });

const applyInputLimits = container => {
  if (!container) return;
  const inputs = container.querySelectorAll('input[type="text"], input[type="tel"]');
  inputs.forEach(input => {
    const label = input.closest(".form-group")?.querySelector("label");
    const text = label?.textContent?.toLowerCase().trim() || "";
    if (text.includes("phone")) {
      input.setAttribute("maxlength", String(PHONE_LIMIT));
    } else if (
      text.includes("first name") ||
      text.includes("last name") ||
      text.includes("email") ||
      text.includes("e-mail")
    ) {
      input.setAttribute("maxlength", String(NAME_LIMIT));
    }
  });
};

const FormGeneratorComponent = ({
  formStructure,
  syncValuesWithFormik,
  answerData
}) => {
  const formBuilderRef = useRef(null);
  const formData = formatDateInFormData(formStructure);

  const filterFormData = sanitizeItems(formData);

  useEffect(() => {
    const timer = setTimeout(() => {
      applyInputLimits(formBuilderRef.current);
    }, 100);

    const observer = new MutationObserver(() => {
      applyInputLimits(formBuilderRef.current);
    });

    if (formBuilderRef.current) {
      observer.observe(formBuilderRef.current, {
        childList: true,
        subtree: true
      });
    }

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [filterFormData]);

  return (
    <Wrapper ref={formBuilderRef}>
      <ReactFormGenerator
        variables={variables}
        data={filterFormData}
        answer_data={answerData || []}
        task_id={12}
        onChange={event => {
          syncValuesWithFormik(truncateNameFields(event));
        }}
        onBlur={event => {
          syncValuesWithFormik(truncateNameFields(event));
        }}
        hide_actions
      />
    </Wrapper>
  );
};

export default FormGeneratorComponent;
